
import { Policy } from "@/types";

// Draft policies for demo
export const draftPolicies: Policy[] = [
  {
    id: "privacy-policy-draft",
    title: "Privacy Policy (Draft)",
    description: "Updated privacy policy with GDPR compliance information",
    content: "This privacy policy outlines how our company collects, uses, and safeguards your personal information. We are committed to protecting your privacy and handling your data with transparency. This policy explains what information we collect, how we use it, and your rights regarding your data.\n\nInformation We Collect: We collect personal information such as your name, email address, and other contact details when you register for an account. We may also collect usage data and cookies to improve our services.\n\nHow We Use Your Information: Your information helps us provide and improve our services, communicate with you, and ensure security of our platform.\n\nData Security: We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.\n\nGDPR Compliance: For users in the European Union, we comply with GDPR requirements. You have the right to access, modify, or delete your personal data. Contact our Data Protection Officer at dpo@example.com for any inquiries regarding your data.",
    createdAt: "2023-01-15T10:30:00Z",
    updatedAt: new Date().toISOString(),
    reviewDate: "2023-05-15T00:00:00Z",
    ownerId: "1",
    requiredUserTypes: ["admin", "doctor", "nurse"],
    version: "1.0",
    isReviewOverdue: true,
    isDraft: true,
    editLog: [
      {
        editedBy: "Dr. Emma Taylor",
        timestamp: "2022-11-05T09:15:00Z",
        changes: "Initial policy creation"
      },
      {
        editedBy: "John Doe",
        timestamp: "2022-12-10T14:30:00Z",
        changes: "Updated data security section"
      },
      {
        editedBy: "Dr. Emma Taylor",
        timestamp: new Date().toISOString(),
        changes: "Added GDPR compliance information"
      }
    ],
    reviews: [
      {
        reviewedBy: "Dr. Emma Taylor",
        timestamp: "2022-11-05T09:15:00Z"
      },
      {
        reviewedBy: "John Doe",
        timestamp: "2023-01-15T10:30:00Z"
      }
    ],
    previousVersions: [
      {
        version: "0.8",
        content: "This privacy policy outlines how our company collects and uses your personal information. We are committed to protecting your privacy.\n\nInformation We Collect: We collect basic personal information such as your name and email address when you register.\n\nHow We Use Your Information: Your information helps us provide our services.\n\nData Security: We take basic measures to protect your data.",
        updatedAt: "2022-11-05T09:15:00Z"
      },
      {
        version: "0.9",
        content: "This privacy policy outlines how our company collects and uses your personal information. We are committed to protecting your privacy and handling your data responsibly.\n\nInformation We Collect: We collect personal information such as your name, email address when you register for an account.\n\nHow We Use Your Information: Your information helps us provide our services and communicate with you.\n\nData Security: We implement security measures to protect your personal information.",
        updatedAt: "2022-12-10T14:30:00Z"
      }
    ]
  }
];
